import { Component } from '@angular/core';

@Component({
  selector: 'comp-dialog-footer',
  templateUrl: 'dialog-footer.component.html',
  styleUrls: ['dialog-footer.component.scss'],
})
export class DialogFooterComponent {}
